import { RouterModule, Routes } from '@angular/router';

/* GUARDS */
import { AuthGuard } from '../guards/auth.guard';

/* COMPONENTS */
import { DashboardComponent } from './dashboard.component';
import { Error404Component } from './error-404/error-404.component';
import { SystemOptionsComponent } from './system-options/system-options.component';
import { RoleComponent } from './role/role.component';
import { RoleInfoComponent } from './role/role-info.component';
import { CreateRoleComponent } from './role/create-role.component';
import { PermissionComponent } from './permission/permission.component';
import { UserComponent } from './user/user.component';
import { UserInfoComponent } from './user/user-info.component';
import { CreateUserComponent } from './user/create-user.component';
import { IndexComponent } from './index/index.component';
import { ParamComponent } from './param/param.component';
import {MenuComponent} from './menu/menu.component';
import {MenuInfoComponent} from './menu/menu-info.component';
import {SliderListComponent} from './slider/slider-list.component';
import {SliderComponent} from './slider/slider.component';
import {CreateSliderComponent} from './slider/create-slider.component';
import { BankListComponent } from './bank/bank-list.component';
import { BankDetailComponent } from './bank/bank-detail.component';
import { CreateBankComponent } from './bank/create-bank.component';
import { ContractListComponent } from './contract/contract-list.component';
import { ContractComponent } from './contract/contract.component';

import { EvaluationListComponent } from './evaluation/evaluation-list.component';
import { EvaluationDetailComponent } from './evaluation/evaluation-detail.component';
import { PropertyListComponent } from './property/property-list.component';
import { PropertyComponent } from './property/property.component';
import { DivisionListComponent } from './division/division-list.component';
import { DivisionComponent } from './division/division.component';
import { TenantListComponent } from './tenant/tenant-list.component';
import { TenantComponent } from './tenant/tenant.component';


const dashboardRoutes: Routes = [
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    component: DashboardComponent,
    children: [
      {
        path: '',
        component: IndexComponent
      },
      {
        path: 'system-options',
        component: SystemOptionsComponent
      },
      {
        path: 'roles',
        component: RoleComponent
      },
      {
        path: 'role',
        component: CreateRoleComponent
      },
      {
        path: 'role/:id',
        component: RoleInfoComponent
      },
      {
        path: 'permission/:id',
        component: PermissionComponent
      },
      {
        path: 'users',
        component: UserComponent
      },
      {
        path: 'user/:id',
        component: UserInfoComponent
      },
      {
        path: 'user',
        component: CreateUserComponent
      },
      {
        path: 'params',
        component: ParamComponent
      },
      {
        path: 'banks',
        component: BankListComponent
      },
      {
        path: 'bank/:id',
        component: BankDetailComponent
      },
      {
        path: 'bank',
        component: CreateBankComponent
      },
      {
        path: 'menus',
        component: MenuComponent
      },
      {
        path: 'menu/:id',
        component: MenuInfoComponent
      },
      {
        path: 'contracts',
        component: ContractListComponent
      },
      {
        path: 'contracts/:id',
        component: ContractComponent
      },
      {
        path: 'properties',
        component: PropertyListComponent
      },
      {
        path: 'properties/:id',
        component: PropertyComponent
      },
      {
        path: 'evaluations',
        component: EvaluationListComponent
      },
      {
        path: 'evaluations/:id',
        component: EvaluationDetailComponent
      },
      {
        path: 'divisions',
        component: DivisionListComponent
      },
      {
        path: 'divisions/:id',
        component: DivisionComponent
      },
      {
        path: 'tenants',
        component: TenantListComponent
      },
      {
        path: 'tenants/:id',
        component: TenantComponent
      },
      {
        path: 'sliders',
        component: SliderListComponent
      },
      {
        path: 'sliders/:id',
        component: SliderComponent
      },
      {
        path: 'slider',
        component: CreateSliderComponent
      },
      {
        path: 'evaluations',
        component: EvaluationListComponent
      },
      {
        path: 'evaluations-detail',
        component: EvaluationDetailComponent
      },
      {
        path: '404',
        component: Error404Component
      },
      {
        path: '**',
        component: Error404Component
      }
    ]
  },
];

export const routing_dashboard = RouterModule.forRoot(dashboardRoutes);




// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/dashboard.routing.ts